// extracted by mini-css-extract-plugin
export default {"container":"artwork-recieved_container__Yp4gn","artworkBox":"artwork-recieved_artworkBox__8UwGS","outerBox":"artwork-recieved_outerBox__c0eTc"};